import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { ElvisDSModule } from 'ngx-elvis-ds';

import { GUIBaseModule } from '../../gui-base/gui-base.module';
import { NumericInputDialogPage } from './numeric-input-dialog.page';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        GUIBaseModule,
        ElvisDSModule,
    ],
    declarations: [
        NumericInputDialogPage
    ]
})
export class NumericInputDialogPageModule {}
